/**
 * Service pour détecter et gérer l'état du backend API
 */

let backendHealthStatus: 'unknown' | 'healthy' | 'unhealthy' = 'unknown';
let lastHealthCheck = 0;
const HEALTH_CHECK_INTERVAL = 30000; // 30 secondes

/**
 * Vérifie si le backend est disponible
 */
export async function checkBackendHealth(): Promise<boolean> {
  const now = Date.now();
  
  // Éviter les vérifications trop fréquentes
  if (now - lastHealthCheck < HEALTH_CHECK_INTERVAL && backendHealthStatus !== 'unknown') {
    return backendHealthStatus === 'healthy';
  }
  
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5s timeout
    
    // Essayer un endpoint simple ou de santé
    const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:8000/land/api/v1'}/health`, {
      method: 'GET',
      signal: controller.signal,
      headers: {
        'Accept': 'application/json'
      }
    });
    
    clearTimeout(timeoutId);
    
    if (response.ok) {
      backendHealthStatus = 'healthy';
      lastHealthCheck = now;
      console.log('✅ Backend API est disponible');
      return true;
    } else {
      console.warn(`⚠️ Backend API répond avec status ${response.status}`);
      backendHealthStatus = 'unhealthy';
      lastHealthCheck = now;
      return false;
    }
  } catch (error) {
    console.warn('⚠️ Backend API non disponible:', error);
    backendHealthStatus = 'unhealthy';
    lastHealthCheck = now;
    return false;
  }
}

/**
 * Récupère le statut actuel du backend sans faire de requête
 */
export function getBackendHealthStatus(): 'unknown' | 'healthy' | 'unhealthy' {
  return backendHealthStatus;
}

/**
 * Force une nouvelle vérification du backend
 */
export function forceBackendHealthCheck(): Promise<boolean> {
  lastHealthCheck = 0;
  return checkBackendHealth();
}
